import { PartnershipRequestInvoker } from '@purchase/supplier';

const invoker = PartnershipRequestInvoker.getInstance();

/**
 * 协同端事故列表分页查询
 */
export const fetchAccidentList = (params: any) => {
  return invoker.partnerShipOpenApiAccidentList(params);
};

/**
 * 协同端事故详情查询
 * 走 invoker.partnerShipOpenApiAccidentDetail（api: cooperation.accident.detail，与列表同链路）。
 * 注：该接口后端曾返回 4004「数据不存在」，根因在后端协同端详情查询逻辑（前端传参无误）。
 */
export const fetchAccidentDetail = (params: { accidentId: number }) => {
  return invoker.partnerShipOpenApiAccidentDetail({
    accidentId: params.accidentId,
  });
};

/**
 * 协同端 Tab 计数：按 scope 各取 total
 */
export const fetchAccidentTabCounts = async () => {
  const [pendingRes, allRes] = await Promise.all([
    invoker.partnerShipOpenApiAccidentList({
      pageNo: 1,
      pageSize: 1,
      scope: 'PENDING',
    }),
    invoker.partnerShipOpenApiAccidentList({
      pageNo: 1,
      pageSize: 1,
      scope: 'ALL',
    }),
  ]);

  return {
    data: {
      PENDING: pendingRes?.data?.total || 0,
      ALL: allRes?.data?.total || 0,
    },
  };
};
